import { CSuiteBaseService } from "./CSuiteBaseServices";

class CouponService extends CSuiteBaseService {
  getCoupon = (id) => {
    return this.get(`payment/get-coupon?id=${id}`);
  };
}

export default new CouponService();
